import { render, staticRenderFns } from "./distributionLevel.vue?vue&type=template&id=5b199b1e&scoped=true&"
import script from "./distributionLevel.vue?vue&type=script&lang=js&"
export * from "./distributionLevel.vue?vue&type=script&lang=js&"
import style0 from "./distributionLevel.vue?vue&type=style&index=0&id=5b199b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b199b1e",
  null
  
)

export default component.exports